



































































































































import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import { billingType } from '@/modules/Policy/helpers/policy'
import { Quote } from '@/modules/Quote/interfaces/quote'
import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import AppDialog from '@/components/AppDialog.vue'
import AcordFormDialog from '@/components/AcordFormDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import { RecordType } from '@/modules/RecordType/interfaces/record-type'
import { quoteStatus, quoteStatusClass, quoteStatusKeys, quoteStatusValues, quoteTypeKeys, quoteTypeValues } from '@/modules/Quote/helpers/quote'
import { mixins } from 'vue-class-component'
import QuoteDialog from '@/modules/Quote/scripts/quote-dialog'
import { ApolloResponse } from '@/interfaces/apollo'
import { showErrors } from '@/utils/snack'
import { getQuotePremiums } from '@/modules/Quote/gql/quote.gql'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import QuoteRequestTypeInForm from '@/modules/Quote/components/QuoteRequestTypeInForm.vue'
import QuotePremiumInfo from '@/modules/Quote/components/QuotePremiumInfo.vue'
import QuoteRequestMailForm from '@/modules/Quote/components/QuoteRequestMailForm.vue'
import QuoteRequestTypeDialog from '@/modules/Quote/components/QuoteRequestTypeDialog.vue'
import { QuoteCarrier } from '@/modules/Quote/interfaces/quote-carrier'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard,
    QuoteRequestTypeInForm,
    QuotePremiumInfo,
    AcordFormDialog,
    QuoteRequestTypeDialog,
    QuoteRequestMailForm
  }
})
export default class QuoteDetailDetail extends mixins(QuoteDialog) {
  @Prop({ type: Object as () => Quote }) readonly quote!: Quote
  @Prop({ type: Object as () => RecordType }) readonly recordType!: RecordType
  @Prop({ type: Object as () => { [key: string]: any; } }) readonly additionalInput!: { [key: string]: any; }

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay

  quoteStatus = quoteStatus

  additionalInfoCards: {
    title: string;
    items: {[key: string]: any;}[]
  }[] = []

  quoteAdditional: {
    [key: string]: any;
  } = {}

  requestTypeInForm = {
    show: false,
    step: 0
  }

  quoteCarriers: QuoteCarrier[] = []

  quoteStatusClass = quoteStatusClass
  billingType = billingType

  quoteStatusKeys = quoteStatusKeys
  statusOptions = quoteStatusValues
  quoteTypeKeys = quoteTypeKeys
  typeOptions = quoteTypeValues

  acordFormDialog = {
    show: false
  }

  typeDialog = {
    show: false
  }

  requestMailForm = {
    show: false
  }

  get priorTermRoute () {
    return {
      name: 'PolicyDetailDetail',
      params: {
        id: this.quote.priorTerm.id
      }
    }
  }

  get accountRoute () {
    return {
      name: 'AccountDetailDetail',
      params: {
        id: this.quote.account.id
      }
    }
  }

  get contactRoute () {
    return {
      name: 'ContactDetailDetail',
      params: {
        id: this.quote.primaryContact.id
      }
    }
  }

  get carrierRoute () {
    return {
      name: 'CarrierDetailDetail',
      params: {
        id: this.quote.carrier.id
      }
    }
  }

  get carrierProductRoute () {
    return {
      name: 'CarrierProductDetailDetail',
      params: {
        id: this.quote.carrierProduct.id
      }
    }
  }

  get billingTypeOptions () {
    return this.$R.keys(billingType).map((key: string) => {
      return {
        label: billingType[key],
        value: key
      }
    })
  }

  async mounted () {
    this.onQuoteUpdated(this.quote)
  }

  @Watch('quote', { deep: true })
  onQuoteUpdated (val: Quote) {
    this.quoteCarriers = val.premiums
    this.onRecordTypeChanged(this.recordType)
  }

  @Watch('recordType', { deep: true })
  onRecordTypeChanged (val: RecordType) {
    this.additionalInfoCards = val.additionalInfo
    this.quoteAdditional = JSON.parse(this.quote.additionalInfoStr)
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  showRequestQuoteDialog () {
    this.typeDialog.show = true
  }

  typeSelectedHandler (idx: number) {
    if (idx === 0) {
      this.requestTypeInForm.show = true
    } else {
      this.requestMailForm.show = true
    }
  }

  @Emit('edit')
  editQuote (step: number) {
    return step
  }

  async getQuoteCarriers () {
    const quoteId = Number(this.quote.id)

    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getQuotePremiums,
        variables: {
          quoteId
        }
      })

      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.quoteCarriers = result.data.getQuotePremiums
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  showAcordFormDialog () {
    this.acordFormDialog.show = true
  }

  hideAcordFormDialog () {
    this.acordFormDialog.show = false
  }
}
